import React, { useState } from 'react'
import { Modal, Empty, Button, Icon, Input, Tag } from 'antd'
import './CharacterSelectionModal.scss'

const CharacterSelectionModal = ({
  visible,
  onCancel,
  onSelect,
  characterList = [],
  selectedCharacter = [],
  currentCharacterKey
}) => {
  const [searchText, setSearchText] = useState('')

  const filteredCharacters = characterList.filter(char => {
    const query = searchText.toLowerCase()
    return (
      (char.name || '').toLowerCase().includes(query) ||
      (char.gender || '').toLowerCase().includes(query) ||
      (char.attributes?.original_prompt || '').toLowerCase().includes(query)
    )
  })

  const renderCharacterItem = char => {
    const attrs = char.attributes || {}
    const pic = attrs.profile_pic || ''

    // Resolve currentCharacterKey using selectedCharacter mapping
    const mapping = selectedCharacter.find(
      m =>
        m.original === currentCharacterKey || m.current === currentCharacterKey
    )
    const resolvedName = mapping
      ? mapping.current.replace(/^__|__$/g, '')
      : currentCharacterKey
      ? currentCharacterKey.replace(/^__|__$/g, '')
      : null
    const isSelected = resolvedName && resolvedName === char.name

    return (
      <div
        key={char.id || char.name}
        className={`character-card-item ${isSelected ? 'is-selected' : ''}`}
      >
        {isSelected && (
          <div className="selected-badge">
            <Icon type="check" />
          </div>
        )}

        <div className="character-image-wrapper">
          {pic ? (
            <img src={pic} alt={char.name} />
          ) : (
            <div className="no-image">
              <Icon type="user" />
              <span>No Image</span>
            </div>
          )}
        </div>

        <div className="character-content">
          <div className="character-header">
            <h4 title={char.name}>{char.name}</h4>
            <div className="character-meta">
              <Tag
                color={
                  char.gender === 'male'
                    ? 'blue'
                    : char.gender === 'female'
                    ? 'magenta'
                    : 'default'
                }
              >
                {char.gender.toUpperCase()}
              </Tag>
            </div>
          </div>

          <div className="character-action">
            {isSelected ? (
              <Button type="dashed" block className="selected-btn">
                <Icon type="check-circle" /> Selected
              </Button>
            ) : (
              <Button
                type="primary"
                ghost
                block
                onClick={() => onSelect(char.name)}
              >
                Select
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <Modal
      title="Select Character Reference"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      centered
      wrapClassName="character-selection-modal"
    >
      <div className="character-search-wrapper">
        <Input
          placeholder="Search characters by name or gender..."
          prefix={<Icon type="search" />}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          allowClear
        />
      </div>

      {filteredCharacters.length > 0 ? (
        <div className="character-grid">
          {filteredCharacters.map(renderCharacterItem)}
        </div>
      ) : (
        <Empty
          description={
            searchText
              ? 'No matching characters found.'
              : 'No characters available.'
          }
        />
      )}
    </Modal>
  )
}

export default CharacterSelectionModal
